import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICellRendererParams } from "ag-grid-enterprise";
import React from "react";

const DirectionCellRenderer: React.FC<ICellRendererParams> = React.memo(
  ({ data, value }) => {
    if (!data) {
      return null;
    }
    return (
      <div>
        {value === "incoming" ? (
          <FontAwesomeIcon icon={faArrowDown} color="red" size="1x" />
        ) : (
          <FontAwesomeIcon icon={faArrowUp} color="green" size="1x" />
        )}
      </div>
    );
  }
);

DirectionCellRenderer.displayName = "DirectionCellRenderer";
export default DirectionCellRenderer;
